import { organizationSubscriptionFeature } from './organization-subscription.feature';
import { createSelector } from '@ngrx/store';
import { OrganizationSubscriptionItem } from './models/organization-subscription.model';

const { selectSubscription, selectError } = organizationSubscriptionFeature;

const selectSubscriptionItems = createSelector(
  selectSubscription,
  (subscription): OrganizationSubscriptionItem[] => subscription?.items ?? [],
);

const selectAddonSubscriptionItems = createSelector(
  selectSubscriptionItems,
  (items): OrganizationSubscriptionItem[] =>
    items.filter((item) => {
      const productPlanType = item.product.metadata?.planType ?? '';
      const pricePlanType = item.price.metadata?.planType ?? '';
      // only keep alphabets
      const sanitisedProductPlanType = productPlanType.toLowerCase().replace(/[^a-z]/g, '');
      const sanitisedPricePlanType = pricePlanType.toLowerCase().replace(/[^a-z]/g, '');
      return sanitisedProductPlanType === 'addon' || sanitisedPricePlanType === 'addon';
    }),
);

const selectBaseSubscriptionItem = createSelector(
  selectSubscriptionItems,
  (items): OrganizationSubscriptionItem =>
    items.find((item) => item.product.metadata?.orgType?.length > 0),
);

// Export all selectors
export const OrganizationSubscriptionSelectors = {
  // Base selectors
  selectSubscription,
  selectError,
  selectSubscriptionItems,
  selectAddonSubscriptionItems,
  selectBaseSubscriptionItem,
};
